// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__Us-9g","alert":"SettungsInbox_alert__9wyaF"};